import apiClient from 'services/axios'
import store from 'store'

const applicationId = process.env.REACT_APP_APPLICATION_ID

export async function login(loginId, password) {
  return apiClient
    .post('/api/login', {
      applicationId,
      loginId,
      password,
    })
    .then(response => {
      if (response) {
        const { token, refreshToken} = response.data
        if (token) {
          store.set('accessToken', token)
        }
        if(refreshToken){
          store.set('refreshToken', refreshToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => {
      console.error(err)
      return false
    })
}

export async function register(email, password, name) {
  return apiClient
    .post('/api/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { token, refreshToken} = response.data
        if (token) {
          store.set('accessToken', token)
          store.set('refreshToken', refreshToken)
          console.log(token)
        }
        return response.data
      }
      return false
    })
    .catch(err => {
      console.log(err)
      return false
    })
}

export async function currentAccount() {
  return apiClient
    .get('/api/user')
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.set('accessToken', token)
        }
        return response.data
      }
      return false
    })
    .catch(err => {
      console.log('Err', err)
      let dta = false
      if(err?.response?.status === 401){  
        console.log(401)      
        const refreshToken = store.get('refreshToken')
        return apiClient
          .post('/api/jwt/refresh',{
            refreshToken
          })
          .then(response => {
            if (response) {
              const {token} = response.data
              if (token) {
                store.set('accessToken', token)
              }
               dta = response.data
               return dta
            }
            store.remove('accessToken')
            store.remove('refreshToken')
            return dta
          })
          .catch(error => 
            {
              console.log(error)
              store.remove('accessToken')
              store.remove('refreshToken')
              return dta
            })
      }
      return dta
    })
}

export async function logout() {  
  const refreshToken = store.get('refreshToken')
  return apiClient
    .post('/api/logout',{
        refreshToken
    })
    .then(() => { 
      store.remove('accessToken')
      store.remove('refreshToken')     
      return true
    })
    .catch(err => console.log(err))
}

